export const TOMB_TICKER = 'TOMB';
export const TSHARE_TICKER = 'TSHARE';
export const TBOND_TICKER = 'TBOND';
export const FTM_TICKER = 'FTM';
export const WFTM_TICKER = 'WFTM';
export const SPOOKY_ROUTER_ADDR = '0x10ED43C718714eb63d5aA57B78B54704E256024E';
export const ZAPPER_ROUTER_ADDR = '0x8bb1fe7a50082623b372d857b4d07911c786a3e9';
export const TAX_OFFICE_ADDR = '0xcaf6C0FB8Bcb737C2D5D7e5Db615147a26091De1';
